import { FlexboxGrid, RadioV2 as Radio, mediaQueries, style } from '@do/walrus';
import React from 'react';
import styled from 'styled-components';
import type { GetAddonsByApp_getAddonsByApp_addons as Addon } from '../../graphql/generated-types/GetAddonsByApp';
import { GetSaasAppBySlug_GetSaasAppBySlug_app_plans as SaasPlan } from '../../graphql/generated-types/GetSaasAppBySlug';
import { FeatureList } from '../PlansSelector/FeatureList';

const StyledFlexboxGrid = styled(FlexboxGrid)<{ isInIframe?: boolean }>`
  box-sizing: border-box;
  margin: ${(props) => (props.isInIframe ? `${style.vars.space['3']} 0` : 0)};
`;

const StyledFlexboxGridCol = styled(FlexboxGrid.Col)`
  padding: 0;

  ${mediaQueries.mediumMin} {
    &:first-of-type {
      padding-right: ${style.vars.space['3']};
    }
  }
`;

interface LicenseAddonsPlansTabProps {
  addon: Addon;
  isInIframe?: boolean;
  selectedPlan?: string;
  setSelectedPlan?: React.Dispatch<React.SetStateAction<string>>;
  plans: SaasPlan[];
}

const LicenseAddonsPlansTab: React.FC<LicenseAddonsPlansTabProps> = ({
  addon,
  selectedPlan,
  setSelectedPlan,
  plans,
  isInIframe
}) => {
  const isMobile = mediaQueries.smallMax.useMatchesBreakpoint();
  const addonPlans = addon?.plans || [];

  const defaultPlan = plans.find((plan) => plan.by_default) || plans[0];
  const defaultPlanSlug = defaultPlan.slug;
  const selectedPlanData =
    plans.find((plan) => plan.slug === selectedPlan) || defaultPlan;
  const planFeatures = selectedPlanData.features || [];

  return (
    <StyledFlexboxGrid isInIframe>
      <h2>Plans</h2>
      <StyledFlexboxGridCol md={5}>
        <Radio.Group
          name="add-on-plans"
          selected={selectedPlan || defaultPlanSlug}
          onSelect={(value) => setSelectedPlan(value)}
        >
          <>
            {addonPlans.map((plan) => (
              <Radio.Button
                value={plan.slug}
                title={plan.display_name}
                subtitle={`$${plan.price_per_month}/month`}
                key={plan.slug}
              />
            ))}
          </>
        </Radio.Group>
      </StyledFlexboxGridCol>
      <StyledFlexboxGridCol md={7}>
        {(!isMobile || isInIframe) && (
          <FeatureList planFeatures={planFeatures} />
        )}
      </StyledFlexboxGridCol>
    </StyledFlexboxGrid>
  );
};

export default LicenseAddonsPlansTab;
